<section class="card widget-shell h-100">
  <header class="card-header" draggable="true" (dragstart)="dragStarted.emit($event)" (dragend)="dragEnded.emit()">
    <div class="title"><span class="icon"><i [ngClass]="['fas', icon]" aria-hidden="true"></i></span><strong>{{ title }}</strong></div>
    <div class="actions">
      <button class="btn btn-light btn-sm" type="button" [disabled]="!canMoveLeft" (click)="moveLeft.emit()"><i class="fas fa-arrow-left" aria-hidden="true"></i></button>
      <button class="btn btn-light btn-sm" type="button" [disabled]="!canMoveRight" (click)="moveRight.emit()"><i class="fas fa-arrow-right" aria-hidden="true"></i></button>
      <button *ngIf="widget.closeable" class="btn btn-light btn-sm" type="button" [disabled]="!canClose"
        (click)="remove.emit(widget)"><i class="fas fa-times" aria-hidden="true"></i></button>
    </div>
  </header>
  <div class="card-body">
    <jbm-dashboard-widget-host
      [widget]="widget"
      (titleChange)="componentTitle=$event"
      (iconChange)="componentIcon=$event">
    </jbm-dashboard-widget-host>
  </div>
</section>
